import { Button, Flex, H1, useBreadcrumbs } from "@inmagik/magik-ui"
import Layout from "../../components/Layout"
import { Persona } from "../../types"
import { useNavigate, useParams } from "react-router-dom"
import { Formik } from "formik"
import { Container } from "react-bootstrap"
import BottomFormFixed from "../../components/BottomFormFixed"
import useModalTrigger from "magik-react-hooks/useModalTrigger"
import ModalDelete from "../../components/ModalDelete"
import { useMemo } from "react"
import { ScrollLayout } from "../../components/ScrollLayout"

import { transformErrorForForm } from "../../utils/utils"
import { useTecnica, useTecnicaDelete, useTecnicaUpdate } from "../../hooks/tecniche"
import { initialValuesTecnica, validationSchemaTecnica } from "./TecnicaCommon"
import TecnicaForm from "./TecnicaForm"

export default function TecnicaUpdate() {
  const updateTecnica = useTecnicaUpdate()
  const navigate = useNavigate()

  const { id } = useParams()

  const { data: tecnica } = useTecnica(Number(id))

  const [modalStateDeleteTecnica, modalActionsDeleteTecnica] = useModalTrigger()

  const deleteTecnica = useTecnicaDelete()

  const initialValues = useMemo(() => initialValuesTecnica(tecnica), [tecnica])
  const validationSchema = useMemo(() => validationSchemaTecnica(), [])

  useBreadcrumbs([{ label: "Tecniche", href: "/tecniche-immagini/tecniche-immagini" }, { label: tecnica?.nome || "..." }])

  return (
    <Layout>
      <ScrollLayout hasBottomFixed>
        <Flex alignItems="center" justifyContent="between">
          <H1>{tecnica?.nome}</H1>
          <Button
            size="md"
            variant="danger"
            title="Elimina"
            leadingIcon="delete"
            onClick={() => {
              modalActionsDeleteTecnica.open()
            }}
          />
        </Flex>
        <ScrollLayout.Scroll>
          <Formik
            enableReinitialize
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={(values, actions) => {
              return updateTecnica.mutateAsync(values as Persona).then(() => {
                navigate(`/tecniche-immagini/tecniche-immagini`)
              }).catch((e) => {
                actions.setErrors(transformErrorForForm(e))
              })
            }}
          >
            {({ handleSubmit }) => (
              <form onSubmit={handleSubmit}>
                <Container fluid className="mt-6">
                  <TecnicaForm />
                </Container>
                <BottomFormFixed url="/tecniche-immagini/tecniche-immagini" />
              </form>
            )}
          </Formik>
        </ScrollLayout.Scroll>
      </ScrollLayout>
      <ModalDelete
        isOpen={modalStateDeleteTecnica.isOpen}
        onClose={modalActionsDeleteTecnica.close}
        onDelete={() => {
          return deleteTecnica.mutateAsync(tecnica?.id).then(() => {
            navigate(`/tecniche-immagini/tecniche-immagini`)
          })
        }}
        message="Sei sicuro di voler eliminare questa tecnica?"
        title="Elimina Tecnica"
      />
    </Layout>
  )
}
